import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ChangeHistoryIcon(props: IconProps) {
    return <Icon {...props} iconKey={"change_history"}/>
}
